// re.rejouis.fr — écran « Mon compte » : connexion Shopify (compte rejouis.fr)
// ou profil connecté + déconnexion.
import { useEffect, useState } from 'react';
import { EcranHeader, Icons, Sticker, CocheAnimee, Spinner } from '../components/ui.jsx';
import { authConfigure } from '../lib/auth.js';
import { chargerDemandes } from '../lib/api.js';
import { DemandeReduite } from './MesDemandes.jsx';

// Demandes de reprise en version réduite, visibles sans clic ; une ligne → son détail.
function MesDemandesReduites({ go }) {
  const [demandes, setDemandes] = useState(null);
  const [erreur, setErreur] = useState(false);
  useEffect(() => {
    let vivant = true;
    chargerDemandes().then((d) => { if (vivant) setDemandes(d); }).catch(() => { if (vivant) setErreur(true); });
    return () => { vivant = false; };
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 12, padding: '0 2px 2px' }}>
        <div>
          <h2 className="t-display" style={{ fontSize: 20, margin: 0 }}>Mes demandes de reprise</h2>
          <div style={{ fontSize: 12, color: 'var(--encre-doux)', marginTop: 2 }}>Les jouets que tu nous revends contre du crédit</div>
        </div>
        {demandes?.length ? (
          <button onClick={() => go('mes-demandes')} style={{ fontSize: 12, fontWeight: 600, color: 'var(--rouge)', padding: 0, whiteSpace: 'nowrap' }}>Tout le suivi</button>
        ) : null}
      </div>
      {erreur ? (
        <button onClick={() => go('mes-demandes')} className="soft-card" style={{ padding: 14, fontSize: 12.5, color: 'var(--encre-doux)', textAlign: 'left' }}>
          Impossible de charger tes demandes ici. Ouvre le suivi complet.
        </button>
      ) : demandes == null ? (
        <div style={{ padding: 16, display: 'flex', justifyContent: 'center' }}><Spinner label="Chargement…" /></div>
      ) : demandes.length === 0 ? (
        <div className="soft-card" style={{ padding: 14, fontSize: 12.5, color: 'var(--encre-doux)', lineHeight: 1.5 }}>
          Aucune demande pour l’instant.{' '}
          <button onClick={() => go('accueil')} style={{ color: 'var(--rouge)', fontWeight: 600, padding: 0, textDecoration: 'underline' }}>Estimer un jouet</button>
        </div>
      ) : (
        demandes.map((d) => <DemandeReduite key={d.ref} d={d} onOuvrir={() => go('mes-demandes', { ref: d.ref })} />)
      )}
    </div>
  );
}

// Carte d'action : icône + titre + sous-titre, bouton (onClick) ou lien (href).
function CarteAction({ icone, titre, sousTitre, onClick, href, externe }) {
  const contenu = (
    <>
      <span style={{ width: 40, height: 40, borderRadius: 12, background: '#fff', color: 'var(--rouge)', display: 'grid', placeItems: 'center', flexShrink: 0 }}>{icone}</span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: 14, fontWeight: 700, color: 'var(--noir)' }}>{titre}</span>
        <span style={{ display: 'block', fontSize: 12, color: 'var(--encre-doux)', marginTop: 2 }}>{sousTitre}</span>
      </span>
      {externe ? <Icons.external size={16} style={{ color: 'var(--stone)' }} /> : <Icons.chev size={16} style={{ color: 'var(--stone)' }} />}
    </>
  );
  const style = { display: 'flex', alignItems: 'center', gap: 12, padding: 14, textAlign: 'left', textDecoration: 'none', width: '100%' };
  return href
    ? <a className="soft-card" href={href} style={style}>{contenu}</a>
    : <button className="soft-card" onClick={onClick} style={style}>{contenu}</button>;
}

export default function Compte({ go, client, onSeConnecter, onDeconnecter }) {
  return (
    <div className="no-scrollbar" style={{ height: '100%', overflow: 'auto', padding: '16px 0 40px' }}>
      <EcranHeader titre="Mon compte" onBack={() => go('accueil')} />

      {client ? (
        <div style={{ padding: '8px 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          {/* Identité : texte centré, pas une carte — ce n'est pas un bouton. */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 6, padding: '4px 0 10px' }}>
            <CocheAnimee size={56} />
            <div className="t-display" style={{ fontSize: 22, marginTop: 4 }}>{client.prenom || client.nomComplet || 'Connecté'}</div>
            <div className="ph-mask" style={{ fontSize: 13, color: 'var(--stone)', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{client.email}</div>
            <div style={{ fontSize: 12, color: 'var(--encre-doux)', marginTop: 2 }}>Ton crédit de reprise est versé sur ce compte rejouis.fr.</div>
          </div>

          {/* Deux usages distincts : d'abord ce qui concerne un ACHAT sur rejouis.fr,
              puis les demandes de REPRISE, sous un vrai titre. */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div className="t-overline" style={{ padding: '0 2px' }}>Mes achats sur rejouis.fr</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 8 }}>
              <CarteAction icone={<Icons.pack size={20} />} titre="Retourner un article commandé"
                sousTitre="Un achat qui ne te convient pas" onClick={() => go('retour')} />
              <CarteAction icone={<Icons.user size={20} />} titre="Mon compte rejouis.fr"
                sousTitre="Commandes, adresses, crédit boutique" href="https://rejouis.fr/account" externe />
            </div>
          </div>

          <div style={{ height: 1, background: 'var(--ligne, rgba(31,25,115,.1))', margin: '10px 0 4px' }} />

          <MesDemandesReduites go={go} />

          <button className="btn btn-tertiary btn-block" onClick={onDeconnecter} style={{ marginTop: 8 }}>Se déconnecter</button>
        </div>
      ) : (
        <div style={{ padding: '8px 18px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 14 }}>
          <Sticker nom="doigts-coeur" size={84} rot={-6} anim="pop" />
          <h2 className="t-display" style={{ fontSize: 26, margin: '0' }}>
            Connecte-toi à ton<br /><span style={{ color: 'var(--rouge)' }}>compte rejouis.fr</span>
          </h2>
          <p style={{ fontSize: 13.5, color: 'var(--stone)', lineHeight: 1.6, margin: 0, maxWidth: 360 }}>
            Ton crédit de reprise sera versé directement dessus. Et si tu as déjà
            commandé chez Rejouis, ton crédit peut être <strong style={{ color: 'var(--noir)' }}>majoré</strong>.
          </p>
          <button className="btn btn-primary btn-block" onClick={onSeConnecter} style={{ marginTop: 4 }}>
            Se connecter avec Rejouis
          </button>
          {!authConfigure() ? (
            <div className="soft-card" style={{ padding: 14, fontSize: 12, color: 'var(--stone)', lineHeight: 1.5 }}>
              Connexion bientôt active : configuration Shopify (Client ID) en cours.
            </div>
          ) : (
            <div style={{ fontSize: 11, color: 'var(--stone)', textAlign: 'center' }}>
              Connexion sécurisée via le compte client Shopify de rejouis.fr
            </div>
          )}
        </div>
      )}
    </div>
  );
}
